// The 'previewScale' is used to adapt the font preview text to match a container.

const defaultFonts = [
  // The default, see Brandings.vue -> newBrandingDefaults.
  {
    text: 'Arial',
    value: 'Arial, sans-serif',
    previewScale: 1.0,
  },
  {
    text: 'Verdana',
    value: 'Verdana, sans-serif',
    previewScale: 0.8,
  },
  {
    text: 'Tahoma',
    value: 'Tahoma, sans-serif',
    previewScale: 0.85,
  },
  {
    text: 'Trebuchet MS',
    value: 'Trebuchet MS, sans-serif',
    previewScale: 1.0,
  },
  {
    text: 'Times New Roman',
    value: 'Times New Roman, serif',
    previewScale: 1.0,
  },
  {
    text: 'Georgia',
    value: 'Georgia, serif',
    previewScale: 0.95,
  },
  {
    text: 'Courier New',
    value: 'Courier New, monospace',
    previewScale: 1.0,
  },
  {
    text: 'Brush Script MT',
    value: 'Brush Script MT, cursive',
    previewScale: 0.9,
  },
];

export function getFontPreviewScaleModifierByFontName(fontName) {
  const font = defaultFonts.filter((font) => font.value === fontName)[0];
  if (!font) {
    return 1.0;
  }
  return font.previewScale;
}

export default defaultFonts;



// WEBPACK FOOTER //
// ./src/mixins/fonts.js